"use strict";

exports.__esModule = true;
exports["default"] = meetsContrastGuidelines;

var _getContrast =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
require("./getContrast"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function meetsContrastGuidelines(color1, color2) {
  var contrastRatio = (0, _getContrast["default"])(color1, color2);
  return {
    AA: contrastRatio >= 4.5,
    AALarge: contrastRatio >= 3,
    AAA: contrastRatio >= 7,
    AAALarge: contrastRatio >= 4.5
  };
}

module.exports = exports.default;